@import '../../style/index';

:host {
  display: block;
  margin-top: var(--spacings-l);

  .video-block__container {
    margin-bottom: rem-calc(48px);
  }

  .image__container {
    position: relative;
    line-height: 0;
    margin-bottom: rem-calc(12px);
    cursor: pointer;

    .desktop-video-button {
      padding: 0;
      margin: 0;
      border: none;
      background: none;
      line-height: 0;
      cursor: pointer;
    }

    .duration {
      position: absolute;
      bottom: rem-calc(10px);
      right: rem-calc(10px);
      color: white;
      background-color: rgb(0 0 0 / 80%);
      border-radius: 4px;
      padding: rem-calc(2px) rem-calc(8px);
      line-height: normal;
      font-size: rem-calc(12px);
    }
  }

  .date {
    @include copy-footnotes();

    margin: 0;
  }

  .video {
    margin: 0;
    min-width: 100%;
    width: 100vw;
    height: calc(100vw / 1.77777778);
    display: block;

    @include medium-up {
      height: calc(650px / 1.77777778);
      max-width: rem-calc(650px);
    }
  }
}
